import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/shared/uikit/ToastV2";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { useUnreadChatThreads } from "../useUnreadChatThreads";

export const useMarkAllChatThreadsAsRead = () => {
  const toast = useToast();
  const { resetNewBadgeIds } = useUnreadChatThreads();
  const { mutateAsync: markAllChatThreadsAsRead, isLoading } = useMutation(
    () => reactQueryPatch(internalApi.chatThreads.markAllAsRead()),
    {
      onSuccess: () => {
        resetNewBadgeIds();
        toast.success(t("header_v3.chat_threads_marked_as_read"));
      },
    },
  );

  return { markAllChatThreadsAsRead, isLoading };
};
